import {
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DxPopupComponent} from 'devextreme-angular';

import {DxDataGridComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import DxDataGrid, {dxDataGridColumn} from 'devextreme/ui/data_grid';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ScreenService} from '../../../../shared/services/general';

@Component({
  selector: 'app-form-relation-selector',
  templateUrl: './form-relation-selector.component.html',
  styleUrls: ['./form-relation-selector.component.scss'],
})
export class FormRelationSelectorComponent implements OnInit, OnDestroy {
  @ViewChild(DxPopupComponent, {static: true}) public popup?: DxPopupComponent;
  @ViewChild('formRelation', {static: false}) public formRelation?: DxDataGridComponent;
  @Input() public popupVisible: boolean = false;
  @Input() public title: string = '';
  @Input() public alternateDataSource: DataSource = new DataSource<any,any>([]);
  @Input() public dataSource: DataSource = new DataSource<any,any>([]);
  public currentDataSource: DataSource = new DataSource<any,any>([]);
  @Input() public keyExpr = 'id';
  @Input() public columns: Array<dxDataGridColumn | string> = [];
  @Output() public closeEvent = new EventEmitter();
  @Input() public control?: UntypedFormControl;
  @Input() public truncatedMode = false;
  public selectedKeys: number[] = [];

  public isPhone: boolean = false;
  public isLoading = false;
  public isPhoneLandscape: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private screen: ScreenService) {
    this.selectRows = this.selectRows.bind(this);
  }

  public ngOnInit() {
    this.isPhone = this.screen.sizes['screen-x-small'];
    this.isPhoneLandscape = this.screen.sizes['screen-small'];
    this.screen.changed.subscribe(() => {
      this.isPhone = this.screen.sizes['screen-x-small'];
      this.isPhoneLandscape = this.screen.sizes['screen-small'];
    });

    this.control?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(keys => {
        if (!keys) return;
        const isEquals = keys.length === this.selectedKeys.length &&
          this.selectedKeys.every((e, i) => e === keys[i]);
        if (!isEquals) {
          this.selectedKeys = keys;
          if (this.formRelation && this.formRelation.instance) {
            this.formRelation.instance.selectRows(this.selectedKeys, false);
          }
        }
      });
  }

  public onShowing() {
    this.currentDataSource = this.truncatedMode ?
      this.alternateDataSource :
      this.dataSource;
    this.currentDataSource?.load();
  }

  public selectRows(e: any) {
    this.formRelation?.instance.selectRows(this.selectedKeys, false);
  }

  public selectionChanged({component}: {component: any}) {
    this.selectedKeys = (component as DxDataGrid).getSelectedRowKeys();
  }

  public submitSelection() {
    this.closeEvent.emit(this.selectedKeys.length > 0 ? this.selectedKeys : undefined);
  }

  public close() {
    this.closeEvent.emit();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
